import React, { forwardRef } from 'react';

import style from './InputShallow.scss';

export const InputShallow = forwardRef(({ className = '', ...other }, ref) =>
    <input
        className={`${style.input} ${className}`}
        ref={ref}
        {...other}
    />
);
